var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45117 24.9999C4.45117 17.1432 4.45117 13.2148 6.89195 10.774C9.33273 8.33325 13.2611 8.33325 21.1178 8.33325H29.4512C37.3079 8.33325 41.2363 8.33325 43.6771 10.774C46.1178 13.2148 46.1178 17.1432 46.1178 24.9999V29.1666C46.1178 37.0233 46.1178 40.9517 43.6771 43.3925C41.2363 45.8332 37.3079 45.8333 29.4512 45.8333H21.1178C13.2611 45.8333 9.33273 45.8332 6.89195 43.3925C4.45117 40.9517 4.45117 37.0233 4.45117 29.1666V24.9999Z",
    stroke: "#41B64D",
    strokeWidth: 3.32143
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8711 8.33301V5.20801",
    stroke: "#41B64D",
    strokeWidth: 3.32143,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7031 8.33301V5.20801",
    stroke: "#41B64D",
    strokeWidth: 3.32143,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49414 18.75H45.0775",
    stroke: "#41B64D",
    strokeWidth: 3.32143,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7897 35.4167C37.7897 36.5673 36.857 37.5 35.7064 37.5C34.5558 37.5 33.623 36.5673 33.623 35.4167C33.623 34.2661 34.5558 33.3333 35.7064 33.3333C36.857 33.3333 37.7897 34.2661 37.7897 35.4167Z",
    fill: "#41B64D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7897 27.0833C37.7897 28.2339 36.857 29.1667 35.7064 29.1667C34.5558 29.1667 33.623 28.2339 33.623 27.0833C33.623 25.9327 34.5558 25 35.7064 25C36.857 25 37.7897 25.9327 37.7897 27.0833Z",
    fill: "#41B64D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3698 35.4167C27.3698 36.5673 26.4371 37.5 25.2865 37.5C24.1359 37.5 23.2031 36.5673 23.2031 35.4167C23.2031 34.2661 24.1359 33.3333 25.2865 33.3333C26.4371 33.3333 27.3698 34.2661 27.3698 35.4167Z",
    fill: "#41B64D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3698 27.0833C27.3698 28.2339 26.4371 29.1667 25.2865 29.1667C24.1359 29.1667 23.2031 28.2339 23.2031 27.0833C23.2031 25.9327 24.1359 25 25.2865 25C26.4371 25 27.3698 25.9327 27.3698 27.0833Z",
    fill: "#41B64D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9518 35.4167C16.9518 36.5673 16.0191 37.5 14.8685 37.5C13.7179 37.5 12.7852 36.5673 12.7852 35.4167C12.7852 34.2661 13.7179 33.3333 14.8685 33.3333C16.0191 33.3333 16.9518 34.2661 16.9518 35.4167Z",
    fill: "#41B64D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9518 27.0833C16.9518 28.2339 16.0191 29.1667 14.8685 29.1667C13.7179 29.1667 12.7852 28.2339 12.7852 27.0833C12.7852 25.9327 13.7179 25 14.8685 25C16.0191 25 16.9518 25.9327 16.9518 27.0833Z",
    fill: "#41B64D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.861f6af4f287704b1036c846a45d7661.svg";
export { ForwardRef as ReactComponent };